<template>
  <el-dialog title="调价" :visible.sync="visible" width="506px" :append-to-body="true" @close="cancelHandle">
    <el-form
      ref="priceForm"
      :model="priceForm"
      :rules="priceRules"
      class="priceForm"
      :label-position="'right'"
      label-width="110px"
    >
      <el-form-item label="基准价格:" prop="basePriceType">
        <el-select v-model="priceForm.basePriceType" style="width: 200px" placeholder="调价方式" @change="baseChange">
          <el-option v-for="item in basePriceTypes" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="调价方式:" prop="adjustmentType">
        <el-select
          v-model="priceForm.adjustmentType"
          style="width: 200px"
          placeholder="调价方式"
          @change="selectChange"
        >
          <el-option
            v-for="item in adjustmentTypeArr"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        v-if="priceForm.adjustmentType === 1"
        key="1"
        label="增幅比例(%):"
        prop="percentage"
        :rules="[{ required: true, validator: validateNumber1, trigger: 'blur' }]"
      >
        <el-input
          v-model.number="priceForm.percentage"
          style="width: 200px"
          placeholder="请输入增幅比例"
          @input="limitInput($event, 'percentage')"
        ></el-input>
        <span class="amplification">(1-100)</span>
      </el-form-item>
      <el-form-item
        v-if="priceForm.adjustmentType === 2"
        key="2"
        label="降幅比例(%):"
        prop="percentage"
        :rules="[{ required: true, validator: validateNumber2, trigger: 'blur' }]"
      >
        <el-input
          v-model.number="priceForm.percentage"
          style="width: 200px"
          placeholder="请输入降幅比例"
          @input="limitInput($event, 'percentage')"
        ></el-input>
        <span class="amplification">(1-80)</span>
      </el-form-item>
      <el-form-item
        v-if="priceForm.adjustmentType === 3"
        key="3"
        label="增幅数值:"
        prop="adjustmentPrice"
        :rules="[{ required: true, validator: validateNumber35, trigger: 'blur' }]"
      >
        <el-input
          v-model="priceForm.adjustmentPrice"
          style="width: 200px"
          placeholder
          @input="limitInput($event, 'adjustmentPrice')"
        ></el-input>
        <span class="amplification">元</span>
      </el-form-item>
      <el-form-item
        v-if="priceForm.adjustmentType === 4"
        key="4"
        label="降幅数值:"
        prop="adjustmentPrice"
        :rules="[{ required: true, validator: validateNumber4, trigger: 'blur' }]"
      >
        <el-input
          v-model="priceForm.adjustmentPrice"
          style="width: 200px"
          placeholder
          @input="limitInput($event, 'adjustmentPrice')"
        ></el-input>
        <span class="amplification">元</span>
      </el-form-item>
      <el-form-item
        v-if="priceForm.adjustmentType === 5"
        key="5"
        label="固定数值:"
        prop="adjustmentPrice"
        :rules="[{ required: true, validator: validateNumber35, trigger: 'blur' }]"
      >
        <el-input
          v-model="priceForm.adjustmentPrice"
          style="width: 200px"
          placeholder
          @input="limitInput($event, 'adjustmentPrice')"
        ></el-input>
        <span class="amplification">元</span>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="cancelHandle">取 消</el-button>
      <el-button type="primary" @click="handleAdjustPrice">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
const numberReg = /^\d+$|^\d+[.]?\d+$/;
const numberReg2 = /^([0-9][0-9]*)+(\.[0-9]{1,2})?$/;
const validateNumber1 = (rule, value, callback) => {
  if (!numberReg.test(value) || value < 1 || value > 100) {
    callback(new Error('输入格式必须为1-100数字'));
  } else {
    callback();
  }
};
const validateNumber2 = (rule, value, callback) => {
  if (!numberReg.test(value) || value < 1 || value > 80) {
    callback(new Error('输入格式必须为1-80数字'));
  } else {
    callback();
  }
};
const validateNumber35 = (rule, value, callback) => {
  if (!numberReg2.test(value) || value < 0 || value > 1000000000) {
    callback(new Error('请输入0-10亿的正数，小数点后最多2位'));
  } else {
    callback();
  }
};

const validateNumber4 = (rule, value, callback) => {
  if (!numberReg2.test(value) || value < 0) {
    callback(new Error('输入格式正数数字，小数点后最多两位'));
  } else {
    callback();
  }
};
const adjustmentTypes = [
  {
    key: 1,
    value: '按比例增幅',
  },
  {
    key: 2,
    value: '按比例降幅',
  },
  {
    key: 3,
    value: '按数值增幅',
  },
  {
    key: 4,
    value: '按数值降幅',
  },
  {
    key: 5,
    value: '固定价',
  },
];

const basePriceTypes = [
  {
    key: 1,
    value: '平台价',
  },
  {
    key: 2,
    value: '协议价',
  },
  {
    key: 3,
    value: '集采价',
  },
];
export default {
  name: 'MultiAdjustPriceDialog',
  components: {},
  props: {
    visible: {
      type: Boolean,
    },
    price: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      // basePriceType	基准价格1-平台价，2-协议价，3-集采价
      dialogTitle: '调价',
      priceForm: {
        adjustmentType: 2,
        percentage: '',
        adjustmentPrice: '',
        basePriceType: 1,
      },
      priceRules: {
        adjustmentType: [{ required: true, message: '请选择调价方式', trigger: 'change' }],
        basePriceType: [{ required: true, message: '请选择基准价格', trigger: 'change' }],
      },
      adjustmentTypeArr: [
        {
          key: 1,
          value: '按比例增幅',
        },
        {
          key: 2,
          value: '按比例降幅',
        },
        {
          key: 3,
          value: '按数值增幅',
        },
        {
          key: 4,
          value: '按数值降幅',
        },
        {
          key: 5,
          value: '固定价',
        },
      ],
      validateNumber1,
      validateNumber2,
      validateNumber4,
      validateNumber35,
      basePriceTypes,
    };
  },
  computed: {},
  created() {
    this.baseChange(1);
  },
  methods: {
    baseChange(val) {
      this.selectChange();
      this.priceForm.adjustmentPrice = '';
      const p = [2, 4, 5];
      if (val === 1) {
        this.adjustmentTypeArr = this.adjustmentTypeArr.filter((item) => {
          return p.includes(item.key);
        });
        this.priceForm.adjustmentType = this.adjustmentTypeArr[0].key;
        return;
      }
      this.adjustmentTypeArr = adjustmentTypes;
      this.priceForm.adjustmentType = this.adjustmentTypeArr[0].key;
    },
    limitInput(value, name) {
      this.priceForm[name] =
        `${value}` // 第一步：转成字符串
          .replace(/[^\d^\.]+/g, '') // 第二步：把不是数字，不是小数点的过滤掉
          .replace(/^0+(\d)/, '$1') // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
          .replace(/^\./, '0.') // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
          .match(/^\d*(\.?\d{0,2})/g)[0] || ''; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，	而且小数点后面只能有0到2位小数
    },

    selectChange() {
      this.priceForm.percentage = '';
      this.priceForm.adjustmentPrice = '';
    },
    cancelHandle() {
      this.$refs.priceForm.resetFields();
      this.$emit('close');
    },
    handleAdjustPrice() {
      this.$refs.priceForm.validate((valid) => {
        if (valid) {
          const params = { ...this.priceForm };
          if (params.adjustmentPrice) {
            delete params.percentage;
          }
          if (params.percentage) {
            delete params.adjustmentPrice;
          }
          if (this.priceForm.adjustmentType === 4) {
            if (this.priceForm.adjustmentPrice - this.price > 0) {
              this.$message({
                message: '降幅数值不可大于市场公开价',
                type: 'warning',
              });
              return;
            }
          }

          this.$nextTick(() => {
            this.$emit('update:visible', false);
            // this.$refs.priceForm.resetFields()
          });
          console.log(this.priceForm, 'this.priceForm');
          this.$emit('handleAdjustPrice', this.priceForm);
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped></style>
